export const COMMON_TABLE_CELL_PADDING = 14;
export const ROW_HOVER_TRANSITION_DELAY = '0.2s';
export const STATUS_CELL_MIN_WIDTH = 108;

export const INITIAL_SEARCH_ICON_COLOR = '#9e9e9e';
export const DEFAULT_SELECTED_SEARCH_ICON_COLOR = '#4caf50';
